export default __webpack_public_path__ + "static/media/checkmark-unchecked.4c818c09.svg";